module.exports = __webpack_public_path__ + "static/media/bigwar-2.5bd51211.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bigwar-2.png
// module id = 98
// module chunks = 0